import { render, staticRenderFns } from "./OnlineMaterials.vue?vue&type=template&id=7e7120f5&"
import script from "./OnlineMaterials.vue?vue&type=script&lang=js&"
export * from "./OnlineMaterials.vue?vue&type=script&lang=js&"
import style0 from "./OnlineMaterials.vue?vue&type=style&index=0&id=7e7120f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports